import type { Tracking } from "../../../ottoec/tracking-bct/nexus.js";
import type { ParameterMap, TrackingParametersMap } from "../parser/params.js";
import { PREFIX } from "../index.js";
import type { DataTrLifeCycleEventMap, DataTrSynteticEventMap } from "./event.types.js";

export const lifecycleEvents = [
  "tr-submit-tracking",
  "tr-track-syntetic",
  "tr-init-element",
] as const satisfies (keyof DataTrLifeCycleEventMap)[];

export const synteticEvents = [
  "tr-become-visible",
  "tr-page-impression",
  "tr-link-move",
  "tr-next-page-impression",
] as const satisfies (keyof DataTrSynteticEventMap)[];

/**
 *
 */
export type TrackingEventDetailData<Method extends keyof ParameterMap> = Partial<{
  [P in ParameterMap[Method][number]]: TrackingParametersMap[P];
}>;

/**
 *
 */
export type GetOriginalEventType<OriginalEvent> =
  /*                                                                */
  OriginalEvent extends keyof DataTrSubmitTrackingOriginalEventMap
    ? /*                                                            */
      DataTrSubmitTrackingOriginalEventMap[OriginalEvent]
    : Event;

/**
 *
 */
type DataTrEventMap = DataTrLifeCycleEventMap & DataTrSynteticEventMap;

/**
 *
 *
 */
type TrEventDetail<M extends keyof ParameterMap, T extends TrackingEventDetailData<M>, I> = I & {
  [PREFIX]: { method?: M } & T;
};

/**
 *
 *
 *
 *
 *
 *
 */
export function createEvent<M extends keyof ParameterMap, T extends TrackingEventDetailData<M>, I>(
  type: string,
  method: M,
  trdata: T,
  init?: CustomEventInit<I>,
): CustomEvent<TrEventDetail<M, T, I>> {
  return new CustomEvent<TrEventDetail<M, T, I>>(type, {
    ...init,
    detail: { ...(init?.detail as I), [PREFIX]: { method, ...trdata } },
  });
}

export function dispatchTrackingEvent<K extends keyof DataTrEventMap>(
  target: EventTarget,
  type: K,
  detail: DataTrEventMap[K]["detail"] & {
    [PREFIX]?: { method?: keyof Tracking } & Record<string, unknown>;
  },
): boolean {
  return target.dispatchEvent(
    new CustomEvent(type, { bubbles: true, composed: true, cancelable: true, detail }),
  );
}
